import { LineStatus } from '../types/kds-line/status';

export function getLinePreviousStatus({
    status,
    isDoubleValidationEnabled,
    isAssembleEnabled,
}: {
    status: LineStatus;
    isDoubleValidationEnabled: boolean;
    isAssembleEnabled: boolean;
}): LineStatus {
    switch (status) {
        case LineStatus.Delivered:
            return LineStatus.Done;

        case LineStatus.Done:
            if (isAssembleEnabled) {
                return LineStatus.ToAssemble;
            }
            if (isDoubleValidationEnabled) {
                return LineStatus.Doing;
            }
            return LineStatus.ToDo;

        case LineStatus.ToAssemble:
            if (isDoubleValidationEnabled) {
                return LineStatus.Doing;
            }
            return LineStatus.ToDo;

        case LineStatus.Doing:
            return LineStatus.ToDo;

        case LineStatus.ToDo:
            return LineStatus.ToDo; // Pas de retour possible avant ToDo

        default:
            return status; // Cancelled, Waiting, New → pas de changement
    }
}
